import { Component } from '@angular/core';

@Component({
  selector: 'app-dashboard',
  template: '<router-outlet></router-outlet>',
})
export class SimpleLayoutComponent { }



// WEBPACK FOOTER //
// C:/Users/bruna/Desktop/nuresp/src/app/containers/simple-layout/simple-layout.component.ts